import React from 'react'
import { DashboarCarddWrapper } from './style'
import CheckboxIcon from '../../images/CheckboxIcon';

function DashboardCard({heading="",desc="",img=null, complate=false, key,onClick=()=>{},disable}) {
  return (
    <DashboarCarddWrapper 
      key={key} 
      onClick={disable?()=>{}:onClick} 
      className={`transition-all duration-300 group ${disable?"":"pointer cursor-pointer"}`}
    >
        <div className={`icons group-hover:bg-[#7BC4E0] transition-all duration-300 ${complate?"active":""}`}>
            <img src={img} alt="icon" className="transition-all duration-300" />
        </div>
        <div className="rightBox">
            <div className="header flex justify-between">
                <h2 className="group-hover:text-[#7BC4E0] transition-all duration-300">{heading}</h2>
                <CheckboxIcon color={complate?"#7BC4E0":"#CBD5E0"} />
            </div>
<p className={`transition-all duration-300 ${disable ? "text-gray-600" : complate ? "text-gray-600" : "text-gray-600 group-hover:text-white"}`}>
  {desc}
</p>
        </div>
    </DashboarCarddWrapper>
  )
}

export default DashboardCard;